import { AwsUi } from '../../runtime/src';
import logger from '../../utils/src/logger';
import { Children, createElement } from 'react';
var RegionsRegistry = /** @class */ (function () {
    function RegionsRegistry(reactComponent, defaultRegionName, reactMount, reactUnmount) {
        this.reactComponent = reactComponent;
        this.defaultRegionName = defaultRegionName;
        this.reactMount = reactMount;
        this.reactUnmount = reactUnmount;
        this.regionNodes = {};
    }
    RegionsRegistry.prototype.updateDefaultRegion = function (contents) {
        if (contents && !this.defaultRegionName) {
            logger.error('Children are not allowed for components without default region');
        }
        if (this.reactComponent.props[this.defaultRegionName]) {
            logger.error("Both default region and explicit region defined for " + this.defaultRegionName);
        }
        if (Children.count(contents) === 0) {
            contents = null;
        }
        this.updateRegion(this.defaultRegionName, contents);
    };
    RegionsRegistry.prototype.updateRegion = function (name, contents) {
        var component = this.reactComponent.getComponent();
        if (contents === null || contents === undefined) {
            this.unmountRegionNode(name);
            component.removeRegion(name);
            return;
        }
        // Shortcut: set the region immediately if input is a string or number
        if (AwsUi.__isPrimitiveRegion(contents)) {
            this.unmountRegionNode(name);
            component[name] = contents;
            return;
        }
        // Shortcut: set region as string or number if passed on as only child
        if (Children.count(contents) === 1) {
            var firstChild = Children.toArray(contents)[0];
            if (AwsUi.__isPrimitiveRegion(firstChild)) {
                this.unmountRegionNode(name);
                component[name] = firstChild;
                return;
            }
        }
        // Unfortunately react needs a DOM node to render into,
        // so we get a double wrapping: one for the node to be rendered
        // in, then the actual react node that is being rendered.
        if (!this.regionNodes[name]) {
            var node = document.createElement('span');
            component.setRegion(name, node);
            this.regionNodes[name] = node;
        }
        var reactContents = null;
        if (Array.isArray(contents)) {
            reactContents = createElement('span', {}, contents);
        }
        else {
            reactContents = Children.only(contents);
        }
        this.reactMount("region-" + name, reactContents, this.regionNodes[name]);
    };
    RegionsRegistry.prototype.unmountAllRegions = function () {
        for (var region in this.regionNodes) {
            this.updateRegion(region, null);
        }
    };
    RegionsRegistry.prototype.unmountRegionNode = function (name) {
        if (this.regionNodes[name]) {
            this.reactUnmount("region-" + name, this.regionNodes[name]);
            delete this.regionNodes[name];
        }
    };
    return RegionsRegistry;
}());
export default RegionsRegistry;
//# sourceMappingURL=RegionsRegistry.js.map